module.exports = __webpack_public_path__ + "img/project6_2.png.67b42eac.webp";